import { Component, ViewChild } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { InventoryService } from '../../../services/inventory.service';
import { Table } from 'jspdf-autotable';
import { gridPageRequest } from '../../../model/common/common.model';
import { SalesService } from '../../../services/sales.service';
import { SharedModule } from '../../../shared/shared.module';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-product-list-lookup',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './product-list-lookup.component.html',
  styleUrl: './product-list-lookup.component.scss'
})
export class ProductListLookupComponent {
  @ViewChild('dt1') dt1: Table | undefined;

  constructor(private inventoryService: InventoryService, private ref: DynamicDialogRef, private salesService: SalesService, private messageService: MessageService) { }

  searchKey: string | undefined;
  products: any[] = [];
  loader: boolean = false

  ngOnInit(): void {
    this.getProducts();
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 10,
    id: 0
  }


  private getProducts() {
    this.loader = true;
    this.inventoryService.getProducts(this.pageRequest).subscribe({
      next: data => {
        this.products = data.products;
        this.loader = false;
      },
      error: error => {
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error retrieving product list. Please try again.' });
        console.log(error);
      }
    })
  }

  onSelect(event: any) {
    if (event?.data) {
      this.ref.close(event?.data);
    } else {
      this.ref.close(event);
    }
  }

  load(event: any): void {
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.search();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getProducts();
    }
  }

  search() {
    if (!this.searchKey) {
      return;
    }
    this.loader = true;
    this.salesService.autoSearchProduct(this.searchKey).subscribe(
      (data: any) => {
        if (data) {
          this.products = data;
          this.loader = false;
        }
        
      },
      (error: any) => {
        this.loader = false;
        console.log(error);
      }
    );

  }

}
